import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ManagerSchedulePage } from './manager-schedule.page';

const routes: Routes = [
  {
    path: '',
    component: ManagerSchedulePage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ManagerSchedulePageRoutingModule {}
